import React from 'react';
import { Center, Text } from '@chakra-ui/react'

const NoRecordFound = ({ textToDisplay, descriptionText }) => {
  return (
    <Center height="60vh" flexDirection="column" p={6} textAlign="center">
      <Text fontSize="xl" fontWeight="semibold" color="gray.600" mb={2}>
        No {textToDisplay} Available
      </Text>
      <Text color="gray.500" maxW="md">
        {descriptionText}
      </Text>
    </Center>
  )
}

export default React.memo(NoRecordFound)
